import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CompanyVendor, Site } from 'src/app/classes/models';
import { CompanyVendorService } from 'src/app/services/company-vendor.service';
import { SharedDataService } from 'src/app/services/shared-data.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-site-vendors-validated',
  templateUrl: './site-vendors-validated.component.html',
  styleUrls: ['./site-vendors-validated.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SiteVendorsValidatedComponent implements OnInit {
  constructor(
    private CompanyVendorService: CompanyVendorService,
    private ToastService: ToastService,
    private SharedDataService: SharedDataService
  ) {}

  Site!: Site;
  CompanyVendors: CompanyVendor[] = [];

  ngOnInit(): void {
    this.SharedDataService.listenForEvent<Site>().subscribe({
      next: ({ eventName, data }) => {
        if (eventName === 'setSiteData' && data) {
          this.Site = data;

          const { id: SiteId, CompanyId } = this.Site;

          if (!SiteId) {
            throw this.ToastService.addErrorToast(
              'Error',
              'Site is missing id.',
              { returnError: true }
            );
          }

          if (!CompanyId) {
            throw this.ToastService.addErrorToast(
              'Error',
              'Missing Client Id.',
              { returnError: true }
            );
          }

          this.CompanyVendorService.getCompanyVendors({
            attributes: JSON.stringify([
              'id',
              'CompanyId',
              'VendorId',
              'viveStatus',
              'viveSubStatus'
            ]),
            CompanyId,
            Vendor: JSON.stringify({
              attributes: ['id', 'legalName', 'dba'],
              options: { required: true },
              StreetAddress: {}
            }),
            InsuranceCertificate: JSON.stringify({
              attributes: ['id'],
              options: { required: true },
              InsurancePolicy: {
                attributes: ['id'],
                options: { required: true },
                InsurancePolicySite: {
                  options: { required: true },
                  SiteId
                }
              }
            })
          }).subscribe({
            next: (CompanyVendors) => {
              this.CompanyVendors.push(...CompanyVendors);
            }
          });
        }
      }
    });

    this.SharedDataService.sendEvent('getSiteData');
  }
}
